import React from 'react';
import numeral from 'numeral';

export default ({ data=[] }) => {

  const products = data.map((product,index) => ({

    id: index.toString(),

    quantity: product.quantity,

    price: {
      actual: product.pricing.price,
      discounted: product.pricing.compare
    },

    image: product.images[0],

    name: product.title,

  }));

  const image = (image_url) => ({
    backgroundImage: `url(${image_url})`
  });

  return (
    <div className='Product-List'>
      {
        products.map(a => (
          <div key={a.id} className='Product'>

            <div className="image" style={image(a.image)}>
              <div className="quantity">{a.quantity}</div>
            </div>

            <div className="content">
              <div className="name">{a.name}</div>
              <div className="price">
                {numeral(a.price.actual).format('0,0')} Ksh
              </div>
            </div>

          </div>
        ))
      }
    </div>
  )
}
